// types of action
const Types = {
    CHANGE_PLAN: "CHANGE_PLAN",
    CHANGE_PAGES: "CHANGE_PAGES",
    CHANGE_ANNUAL_COST: "CHANGE_ANNUAL_COST",
    CHANGE_MONTHLY_COST: "CHANGE_MONTHLY_COST",
    CHANGE_COLOR_INK: "CHANGE_COLOR_INK",
    CHANGE_BLACK_INK: "CHANGE_BLACK_INK",
    CHANGE_INK_TYPE: "CHANGE_INK_TYPE",
    CHANGE_ANNUAL_SAVINGS: "CHANGE_ANNUAL_SAVINGS",
    CHANGE_PANIC_TRIPS: "CHANGE_PANIC_TRIPS",
    CHANGE_HIGH_YIELD_INK: "CHANGE_HIGH_YIELD_INK",
    CHANGE_GENERIC_INK: "CHANGE_GENERIC_INK",
};

// actions
const changePages = pageCount => ({
    type: Types.CHANGE_PAGES,
    payload: pageCount
});
const changeAnnualCost = annualCost => ({
    type: Types.CHANGE_ANNUAL_COST,
    payload: annualCost
});
const changeMonthlyCost = monthlyCost => ({
    type: Types.CHANGE_MONTHLY_COST,
    payload: monthlyCost
});
const changeColorInk = inkCount => ({
    type: Types.CHANGE_COLOR_INK,
    payload: inkCount
});
const changeBlackInk = inkCount => ({
    type: Types.CHANGE_BLACK_INK,
    payload: inkCount
});
const changeInkType = typeOfInk => ({
    type: Types.CHANGE_INK_TYPE,
    payload: typeOfInk
});
const changePlan = planNo => ({
    type: Types.CHANGE_PLAN,
    payload: planNo
});
const changeAnnualSavings = amount => ({
    type: Types.CHANGE_ANNUAL_SAVINGS,
    payload: amount
});
const changePanicTrips = tripCount => ({
    type: Types.CHANGE_PANIC_TRIPS,
    payload: tripCount
});
const changeHighYieldInk = choice => ({
    type: Types.CHANGE_HIGH_YIELD_INK,
    payload: choice
});
const changeGenericInk = choice => ({
    type: Types.CHANGE_GENERIC_INK,
    payload: choice
});

export default {
    changePages,
    changeAnnualCost,
    changeMonthlyCost,
    changeColorInk,
    changeBlackInk,
    changeInkType,
    changeAnnualSavings,
    changePanicTrips,
    changePlan,
    changeHighYieldInk,
    changeGenericInk,
    Types
};
